import * as ActionTypes from "../actions/action_type";

const initialStete = {
  stores: {
    data: [],
  },
};
export const branch_link_state = (state = initialStete, action) => {
  switch (action.type) {
    case ActionTypes.getBranchLinkHistViewSuccessAction: {
      return { ...state, stores: action.payload };
    }
    case ActionTypes.getBranchLinkHistViewFailAction:
    case ActionTypes.getBranchLinkHistViewResetAction:
      return { ...state, stores: initialStete.stores };
    default:
      return state;
  }
};

export const document_info_state = (state = initialStete, action) => {
  switch (action.type) {
    case ActionTypes.getDocumentsViewSuccessAction: {
      return { ...state, stores: action.payload };
    }
    case ActionTypes.getDocumentsViewFailAction:
    case ActionTypes.getDocumentsViewResetAction:
      return { ...state, stores: initialStete.stores };
    default:
      return state;
  }
};
